import { render, staticRenderFns } from "./AppLogoWrapper.vue?vue&type=template&id=5d534810&scoped=true&"
import script from "./AppLogoWrapper.vue?vue&type=script&lang=js&"
export * from "./AppLogoWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d534810",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d534810')) {
      api.createRecord('5d534810', component.options)
    } else {
      api.reload('5d534810', component.options)
    }
    module.hot.accept("./AppLogoWrapper.vue?vue&type=template&id=5d534810&scoped=true&", function () {
      api.rerender('5d534810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/auth/components/AppLogoWrapper.vue"
export default component.exports